<template>
  <div class="notfound content">
    <h3>Not Found</h3>
    <p>
      Woa there, this page doesn't exists!
      <template v-if="lastPath">
        <br>You tried to load <code>{{ lastPath }}</code>, check the URL again.
      </template>
    </p>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data () {
    return {
      lastPath: this.$route?.params?.lastPath
    }
  },
  mounted () {
    document.title = 'Page not found | CN Schedule'
  }
}
</script>

<style lang="scss" scoped>
@use '../assets/colors';

.notfound {
  background-color: var(--page-background-color);
  border: colors.$red 2px solid;
  padding: 25px;
}

@media screen and (min-width: 675px) {
  .notfound {
    margin-left: 200px;
  }
}
</style>
